import { ICartModifiers } from '../interfaces/Cart'

export const createId = (productId: string, options: ICartModifiers[]) => {
    return productId+(`${JSON.stringify(options)}`.split('').sort().toString())
}